import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../lib/language";

export const Header = ({ forceLight = false }) => {
  const { lang, setLang } = useLanguage();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // forceLight=true → page does NOT start on a dark hero, so always use ink colors
  const onDark = forceLight ? false : !scrolled;

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        forceLight
          ? "bg-resilie-bg/85 backdrop-blur-md border-b border-resilie-line"
          : scrolled
          ? "bg-resilie-bg/85 backdrop-blur-md border-b border-resilie-line"
          : "bg-transparent"
      }`}
    >
      <div className="px-6 md:px-12 py-5 md:py-6 grid grid-cols-3 items-center">
        {/* Left: tiny mark */}
        <div
          className={`flex items-center gap-2 ${
            onDark ? "text-white" : "text-resilie-ink"
          }`}
        >
          <span
            data-testid="header-estd"
            className="hidden md:inline font-sans text-[10px] tracking-[0.32em] uppercase opacity-80"
          >
            Estd. 2024
          </span>
        </div>

        {/* Center: brand wordmark */}
        <Link
          to="/"
          data-testid="header-brand"
          className={`justify-self-center font-serif tracking-[0.42em] uppercase font-light text-[18px] md:text-[22px] leading-none ${
            onDark ? "text-white" : "text-resilie-ink"
          }`}
        >
          RESILIÉ
        </Link>

        {/* Right: language toggle */}
        <div
          className={`justify-self-end flex items-center gap-3 ${
            onDark ? "text-white" : "text-resilie-ink"
          }`}
        >
          <button
            type="button"
            data-testid="lang-de-btn"
            onClick={() => setLang("de")}
            className={`nav-link ${lang === "de" ? "is-active" : "opacity-60"}`}
            aria-label="Deutsch"
          >
            DE
          </button>
          <span className="opacity-40 text-[10px]">/</span>
          <button
            type="button"
            data-testid="lang-en-btn"
            onClick={() => setLang("en")}
            className={`nav-link ${lang === "en" ? "is-active" : "opacity-60"}`}
            aria-label="English"
          >
            EN
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
